/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GenerateObjectsPresignedUrlsResponse } from '../../models/generate-objects-presigned-urls-response';
import { PreSignedUrlDto } from '../../models/pre-signed-url-dto';

export interface PresignedUrlForDownload$Params {
  body: Array<PreSignedUrlDto>;
}

export function presignedUrlForDownload(
  http: HttpClient,
  rootUrl: string,
  params: PresignedUrlForDownload$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<GenerateObjectsPresignedUrlsResponse>> {
  const rb = new RequestBuilder(rootUrl, presignedUrlForDownload.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GenerateObjectsPresignedUrlsResponse>;
    })
  );
}

presignedUrlForDownload.PATH = '/v1/presigned/download';
